import React, { useState, useMemo } from "react";
import { useAbilityStore } from "../../store/store";
import DraggableModal from '../Modal/DraggableModal';
import './Trainer.css';

const formatCooldown = (ms) => {
    const totalSeconds = (ms || 0) / 1000;
    if (totalSeconds === 0) return "0s";
    if (totalSeconds < 61) return `${totalSeconds.toFixed(1)}s`;

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    // Optional: Pad seconds with a zero for "1:05" style formatting
    const paddedSeconds = seconds.toString().padStart(2, '0');

    return `${minutes}m${seconds}s`;
};

function AbilityPanel({ sendMessage }) {

    const [selectedAbility, setSelectedAbility] = useState('');


    const abilities = useAbilityStore((state) => state.abilities);
    const points = useAbilityStore((state) => state.points);
    const abilityInfo = useAbilityStore((state) => state.abilityInfo);
    const show = useAbilityStore((state) => state.setShow);

    const [selectedFilter, setSelectedFilter] = useState('all');

    const filteredAbilitiesList = useMemo(() => {
        return abilities?.filter((e) => {
            console.log(e);
            if (selectedFilter === 'all') return true;
            if (selectedFilter === 'ALL-SKILLS' && e.isSpell === "false") return true;
            if (selectedFilter === 'ACTIVE' && e.type === 'ACTIVE') return true;
            if (selectedFilter === 'ALL-SPELLS' && e.isSpell === 'true') return true;
            if (selectedFilter === e.type && e.isSpell === 'true') return true;
            return e.type === selectedFilter;
        });
    }, [selectedFilter, abilities]);


    const hidePanel = () => {
        show(false);
    }

    function selectAbility(id, ability) {
        setSelectedAbility(ability);
        sendMessage("316" + id + "1;ainfo " + ability);

    }


    return (
        <DraggableModal modalId="abilities" onClose={hidePanel}>
            <div className="modal-content">
                <div className="tmodal-header">
                    <span className="close" onClick={hidePanel}>&times;</span>
                    <h2>My Abilities</h2>
                </div>

                <div className="modal-body" style={{ width: '100%', padding: '0px 4px' }}>

                    <div className="ability-container">
                        <div>
                            <div className="ability-list">
                                {
                                    filteredAbilitiesList.map((a) =>
                                        <Ability key={a.name} id={""} ability={a} selectAbility={selectAbility} selectedAbility={selectedAbility} />
                                    )
                                }
                            </div>
                            <select className="learn-filter" onChange={(e) => setSelectedFilter(e.currentTarget.value)}>
                                <option value="all">All</option>
                                <optgroup label="Skills">
                                    <option value="ALL-SKILLS">All Skills</option>
                                    <option value="ACTIVE">Active</option>
                                    <option value="PASSIVE">Passive</option>
                                </optgroup>
                                <optgroup label="Spells">
                                    <option value="ALL-SPELLS">All Spells</option>
                                    <option value="FIRE">Fire</option>
                                    <option value="COLD">Cold</option>
                                    <option value="LIGHT">Light</option>
                                    <option value="DARK">Dark</option>
                                    <option value="AIR">Air</option>
                                    <option value="EARTH">Earth</option>
                                    <option value="ARCANE">Arcane</option>
                                </optgroup>
                            </select>
                        </div>

                        <div className="ability-info">
                            <p className="ability-points">Ability Points (<span className="ability-points-amount">{points}</span>)</p>

                            <div className="info-header">
                                <p>Information</p>
                            </div>

                            {abilityInfo &&
                                <div className="info-desc">
                                    <div className="info-info">
                                        <p className="name">Name <span className="value">{abilityInfo.name}</span></p>
                                        <p className="name">Type <span className="value">{abilityInfo.type}</span></p>
                                        <p className="name">Type2 <span className="value">{abilityInfo.type2}</span></p>
                                          {abilityInfo.type === "SPELL" ?
                                            <>
                                                <p className="name">Mana Cost <span className="value">{abilityInfo.castTime}</span></p>
                                                <p className="name">Cast Time <span className="value">{((abilityInfo?.reuse || 0) / 1000).toFixed(1)}s</span></p>
                                                <span></span>
                                                <p className="name">Level <span className="value">{abilityInfo.level}</span></p>
                                                <p className="name">Cooldown <span className="value">{formatCooldown(abilityInfo.cooldown)}</span></p>
                                                {/* <p className="name">Cooldown <span className="value">{((abilityInfo.cooldown || 0) / 1000).toFixed(1)}s</span></p> */}
                                            </>
                                            :
                                            <>
                                                <p className="name">Recovery Time <span className="value">{((abilityInfo.castTime || 0) / 1000).toFixed(1)}s</span></p>
                                                <p className="name">Cooldown <span className="value">{formatCooldown(abilityInfo.cooldown)}</span></p>
                                                <p></p>
                                                <p className="name">Level <span className="value">{abilityInfo.level}</span></p>

                                            </>
                                        }
                                    </div>
                                    <p className="description">{abilityInfo.desc}</p>
                                    <div className="stats">
                                        <Requirements reqs={abilityInfo.requirements} />
                                        <Modifiers mods={abilityInfo.modifiers} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="ts-close" onClick={hidePanel} >Close</button>
                </div>
            </div>
        </DraggableModal>
    );
}

function Attribute({ name, value }) {
    return (
        <div className="attrib">
            <p className="attrib-name">{name}</p>
            <p className="attrib-value">{value}</p>
        </div>);
}

function Requirements({ reqs }) {
    return (
        <>
            <div className="requirements">
                <h3>Requirements</h3>
                {reqs.map((r, i) => <li key={i} className={r.meetRequirement === 'true' ? 'green' : 'red'}><Attribute name={r.name} value={r.val} /></li>)}
            </div>
        </>
    );
}
function Modifiers({ mods }) {
    return (
        <>
            <div className="modifiers">
                <h3>Modifiers</h3>
                {mods.map((r, i) => <li key={i}><Attribute name={r.name} value={r.val} /></li>)}
            </div>
        </>
    );
}

function Ability({ id, ability, selectAbility, selectedAbility }) {

    return (
        <>
            <div
                className={"ability" + (ability.b !== true ? " req-not-met" : "") + (ability.name === selectedAbility ? " selected" : "")}
                onClick={(e) => selectAbility(id, ability.name)}
            >
                <img className='image' src={require('../../Assets/gfx/' + ability.picId + '.webp')} alt="" />
                <div className={'ability-text'}>
                    <p className={"ability-name" + (ability.b !== true ? " bw" : '')}>{ability.name}</p>
                    <span className="next-level">{ability.level}{ability.cap > 0 && <> (+{ability.cap})</>}</span>
                </div>
                {/* {ability.isSpell && "spell"} */}
            </div>
        </>)
}

export default AbilityPanel;
